import axios from '@api/axiosInstance.js'

export const fetchNewsDetail = async (key) => {
  const res = await axios.post(`/news/detail`, { key })
  return res.data
}